import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ChangeRequestStatusType } from 'src/app/enum/change-request-status-type';
import { RoleType } from 'src/app/enum/role-type';
import { ExcelService } from 'src/app/services/excel.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NotificationService } from 'src/app/services/notification-service';
import { SearchCriteriaDataService } from 'src/app/services/search-criteria-data-service.service';
import { ServiceChangeRequestService } from 'src/app/services/service-change-request.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { ManageCancellationPopupComponent } from '../manage-cancellation-popup/manage-cancellation-popup.component';
import swal from 'sweetalert2';
import { ReportService } from 'src/app/services/report.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { animate, state, style, transition, trigger } from '@angular/animations';


@Component({
  selector: 'app-manage-cancellation',
  templateUrl: './manage-cancellation.component.html',
  styleUrls: ['./manage-cancellation.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*', display: 'block', padding: '15px' })),
      transition('expanded <=> collapsed', animate('100ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ManageCancellationComponent implements OnInit {
  sessionDataString: any;
  retentionAgentName: string | null = null;
  form: FormGroup;
  searchform: FormGroup;
  ChangeRequestStatusType = ChangeRequestStatusType;
  filtershow = false;
  data: any = [];
  dataSource: any = new MatTableDataSource(this.data);
  roletype: any = RoleType;

  displayedColumns: string[] = [
    "CancellationNo",
    "Type",
    "Customer",
    "CustomerNo",
    "ServiceProvider",
    "CurrentService",
    "CreatedOn",
    "RequestedDate",
    "EffectiveOn",
    "Status",
    "action"
  ];
  @ViewChild('startDatePicker') startDateDatePicker: MatDatepicker<Date>;
  @ViewChild('endDatePicker') endDateDatePicker: MatDatepicker<Date>;
  @ViewChild('adminStartDatePicker') adminStartDatePicker: MatDatepicker<Date>;
  @ViewChild('adminEndDatePicker') adminEndDatePicker: MatDatepicker<Date>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  dataExcel: any = [];
  excelColumns: string[];
  filterValue: string = "";
  isMenuClick = false;
  productcategory: any;
  filteredList: any;
  applicationstatus: any;
  filteredList1: any;
  nodata = false;
  constructor(
    private sessionService: UserSessionService,
    private formBuilder: FormBuilder,
    private ServiceChangeRequestService: ServiceChangeRequestService,
    private lookupDataService: LookupDataServiceService,
    private loaderService: LoaderService,
    private toastr: NotificationService,
    private excelService: ExcelService,
    private matdialog: MatDialog,
    private NavigationService: NavigationService,
    private reportservice: ReportService,
    private SearchCriteriaDataService: SearchCriteriaDataService,
  ) { }

  ngOnInit(): void {
    this.sessionDataString = JSON.parse(
      localStorage.getItem(this.sessionService.localStorageSessionKey)
    );
    console.log(this.sessionDataString);

    this.form = this.formBuilder.group({
      serviceProviderId: [],
      changeRequestStatus: [],
      effectiveStartDate: [],
      effectiveEndDate: [],
      adminApprovedEffectiveStartDate: [],
      adminApprovedEffectiveEndDate: []

    })
    this.searchform = this.formBuilder.group({
      searchQuery: [null, Validators.required],
    })
    let filterdata = this.SearchCriteriaDataService.getValue('search');
    console.log(filterdata)
    if (filterdata) {
      if (filterdata.searchQuery) {
        this.searchform.controls['searchQuery'].setValue(filterdata.searchQuery);

        this.getTableData(filterdata);
      } else if (filterdata) {

        Object.keys(filterdata).forEach(key => {
          if (this.form.controls[key]) {
            this.form.controls[key].patchValue(filterdata[key]);
          }
        });

        console.log(this.form.value)

        this.isMenuClick = true;
        this.filter();

      }

    }
    else
      this.getTableData(null);

    this.getproduct();
    this.getApplicationstatus();
  }


  onDateChange(event: any, controlName: string): void {
    const date = event.value;
    const formattedDate = this.formatDate(date);
    this.form.get(controlName)?.setValue(formattedDate);
  }

  formatDate(date: Date | null): string {
    if (!date) return '';
    if (typeof date === 'string') return date;
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }


  getTableData(data: null) {

    this.ServiceChangeRequestService.getServiceCancelRequestOnLoading(data, this.isMenuClick).subscribe((result) => {
      console.log('data', result)
      this.data = result;
      this.dataExcel = result;
      if (this.data.length == 0)
        this.nodata = true;
      else
        this.nodata = false;



      this.dataSource = new MatTableDataSource(this.data);

      this.dataSource.paginator = this.paginator;
    })
  }

  getproduct() {
    this.lookupDataService.getServiceProvider().subscribe((result => {
      this.productcategory = result;
      this.filteredList = [...this.productcategory];
    }))

  }
  getApplicationstatus() {
    this.lookupDataService.getApplicationStatusForCancellation().subscribe((result) => {
      this.applicationstatus = result;
      this.filteredList1 = [...this.applicationstatus];
    })
  }
  clearFilter() {
    this.isMenuClick = true

    this.getTableData(null)
    this.form.reset();
    this.searchform.reset();
    this.SearchCriteriaDataService.removeParticularItem('search');


  }
  toggleAdvancedFilter() {
    this.filtershow = this.filtershow ? false : true;
    console.log(this.filtershow)

  }
  exportAsXLSX(): void {
    this.loaderService.start();
    setTimeout(() => {
      var exportData = this.dataExcel;
      if (!exportData || exportData.length === 0) {
        this.toastr.showInfo("No data available to export");
        this.loaderService.hide();
        return;
      }
      const excelList = [];
      this.excelColumns = [
        "S.No",
        "Ref.No",
        "Customer",
        "Customer No",
        "Service Provider",
        "Current Service",
        "Product Code",
        "Creation On",
        "Requested Date",
        "Effective Date",
        "Status",
        "Reason",
        "Retention Agent Name",
        "Rejected By",
        "Rejected Date",
        "Cancellation Reject Reason",
        "Cancellation With Notice(Logged By)",
        "Retention Promo Code",
        "Retention Start Date",
        "Retention End Date",
        "Retention Applied Date",
      ];
      exportData.forEach((a, index) => {
        let customerName = a.customerName;
        let maskedName = this.encryptionname(customerName);
        excelList.push({
          sno: ++index,
          "Ref.No": a.serviceReferencenumber,
          "Customer": maskedName,
          "Customer No": a.customerReferenceNumber,
          "Service Provider": a.serviceProvider,
          "Current Service": a.aliasName,
          "Product Code": a.productId,
          "Creation On": a.serviceRequestedOn,
          "Requested On": a.requestedCancellationDate,
          "Effective On": a.approveCancellationDate,
          "Status": a.changeRequestStatusName,
          "Reason": a.comments,
          "Retention Agent Name": a.retentionAgentName,
          "Rejected By": a.rejectedBy,
          "Rejected Date": a.lastChangeTs,
          "Cancellation Reject Reason": a.cancellationRejectReasonTypeName === "None" ? null : a.cancellationRejectReasonTypeName,
          "Cancellation With Notice(Logged By)": a.cancelledBy,
          "Retention Promo Code": a.retentionPromoCode,
          "Retention Start Date": a.promotionStartDate,
          "Retention Emd Date": a.promotionEndDate,
          "Retention Applied Date": a.promotionAppliedDate,
        });
      });
      this.excelService.exportAsExcelFile(excelList, "ManageCancellation_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
      this.loaderService.stop();
    }, 500);
  }

  encryptionname(name: string): string {
    const nameParts = name.split(" ");
    let maskedName = nameParts.map(part => {
      if (part.length > 2) {
        return part.substring(0, 2) + 'xxx';
      } else {
        return part;
      }
    }).join(" ");
    return maskedName;
  }
  getStatusClass(status: ChangeRequestStatusType): string {
    switch (status) {
      case this.ChangeRequestStatusType.CancellationAPIFaild:
      case this.ChangeRequestStatusType.CancellationRejected:

        return 'status-failed';
      case this.ChangeRequestStatusType.CancellationCompleted:
        return 'status-completed';
      case this.ChangeRequestStatusType.CancellationPending:
      case this.ChangeRequestStatusType.CancellationWithNotice:
        return 'status-pending';
      case this.ChangeRequestStatusType.NewCancellationRequest:
        return 'status-Request';
      default:
        return '';
    }
  }

  filter() {
    console.log(this.form.value);
    let date = this.form.value;
    if (date.effectiveStartDate && !date.effectiveEndDate) {
      this.form.get('effectiveEndDate')?.setErrors({ 'required': true });
      return;
    }
    if (!date.effectiveStartDate && date.effectiveEndDate) {
      this.form.get('effectiveStartDate')?.setErrors({ 'required': true });
      return;
    }
    if (!date.adminApprovedEffectiveStartDate && date.adminApprovedEffectiveEndDate) {
      this.form.get('adminApprovedEffectiveEndDate')?.setErrors({ 'required': true });
      return;
    }
    if (!date.adminApprovedEffectiveStartDate && date.adminApprovedEffectiveEndDate) {
      this.form.get('adminApprovedEffectiveStartDate')?.setErrors({ 'required': true });
      return;
    }
    else {
      let value = this.getNonNullValues();
      console.log(value)
      this.SearchCriteriaDataService.setValue('search', value, 'filter');

      this.ServiceChangeRequestService.getAdvancedSearchForCancellation(value, true).subscribe((result) => {
        console.log(result)
        if (result) {
          this.data = result
          this.dataSource = new MatTableDataSource(this.data)
          this.dataExcel = result
          this.dataSource.paginator = this.paginator
        }
      })
    }
  }

  search() {
    let value = this.searchform.value;
    console.log(value)
    if (this.searchform.valid) {
      this.SearchCriteriaDataService.setValue('search', value, 'search');
      this.isMenuClick = true;
      this.getTableData(value);
    }
  }


  getNonNullValues(): { [key: string]: any } {
    const rawValues = this.form.value;
    const filteredValues = Object.fromEntries(
      Object.entries(rawValues).filter(([key, value]) => value !== null && value !== undefined)
    );
    return filteredValues;
  }

  view(data: any) {
    let val = { applicationId: data.applicationId, serviceChangeRequestId: data.serviceChangeRequestId, title: 'cancel' }
    this.NavigationService.gotoupgradeapproval(val);
  }


  acknowledgment(data) {
    if (data)
      this.ServiceChangeRequestService.getAcknowledgedComments(data.serviceChangeRequestId).subscribe((result) => {
        result.serviceproviderId = data.serviceProviderId;
        const dialogref = this.matdialog.open(ManageCancellationPopupComponent, {
          autoFocus: false,
          disableClose: true,
          panelClass: 'mat-dialog',
          width: "50%",
          data: {
            head: 'Acknowledgement For Cancellation',
            title: 'acknowledgment',
            data: result,
          }
        });
        dialogref.afterClosed().subscribe((result) => {
          if (result.isAgree == 'yes') {
            let comments = result.data;

            console.log('comments', data.serviceChangeRequestId)
            if (comments) {
              var postData: any = {};
              postData.id = data.serviceChangeRequestId;
              postData.comment1 = comments.comment1;
              postData.comment2 = comments.comment2;
              if (comments.cancellationReasonByAdmin)
                postData.AdminCancellationReason = comments.cancellationReasonByAdmin;
              postData.isAcknowledged = 1;
              postData.applicationId = data.applicationId
              console.log(postData)
              this.ServiceChangeRequestService.saveCommentsForAcknowledgement(postData).subscribe((result) => {
                this.toastr.showSuccess("Cancellation was Acknowledged successfully!");
                this.clearFilter();

              })
            }
          }
        })
      })
    else {
      const dialogref = this.matdialog.open(ManageCancellationPopupComponent, {
        autoFocus: false,
        disableClose: true,
        panelClass: 'mat-dialog',
        width: "30%",
        data: {
          head: 'Acknowledgement For Cancellation',
          title: 'acknowledgment',
        }
      });
      dialogref.afterClosed().subscribe((result) => {
        if (result.isAgree == 'yes') {
          let comments = result.data;

          console.log('comments', result)
          if (comments) {
            var postData: any = {};
            postData.id = data.serviceChangeRequestId;
            postData.comment1 = comments.comment1;
            postData.comment2 = comments.comment2;
            if (comments.cancellationReasonByAdmin)
              postData.adminCancellationReason = comments.cancellationReasonByAdmin;
            postData.isAcknowledged = 1;
            postData.applicationId = data.applicationId
            console.log(postData)
            this.ServiceChangeRequestService.saveCommentsForAcknowledgement(postData).subscribe((result) => {
              this.toastr.showSuccess("Cancellation was Acknowledged successfully!");
              this.clearFilter()

            })
          }
        }
      })
    }
  }



  movetoCancellationComplete(data) {
    var postdata: any = {};
    var cancellationRequest = data;

    postdata.id = cancellationRequest.serviceChangeRequestId
    postdata.connectionId = cancellationRequest.connectionId;
    postdata.applicationId = cancellationRequest.applicationId;
    const txt = 'Are you sure want to Moved to cancellation '
    const Yes = 'Yes';
    const No = 'No';
    swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.ServiceChangeRequestService.moveToCancellationCompleted(postdata).subscribe((result) => {
          if (result) {
            this.toastr.showSuccess("Service Request Changed Succesfully");
            this.clearFilter()
          }
          else
            this.toastr.showError("Sorry, something went wrong!!");
        })
      }
    });

  }


  approve(data, isamend, ismanual = false) {
    var isVumatel;
    var title = "approve";
    var isBalwin;
    if (data.serviceProviderId == 1 && !isamend) {
      title = "vapprove";
      isVumatel = true;
      console.log('v');
    }
    else {
      isVumatel = false;
    }

    if (data.serviceProviderId == 14 && !isamend) {
      title = "bapprove";
      isBalwin = true;
    }
    else {
      isBalwin = false;
    }
    if (ismanual)
      title = "ismanual"

    var shoppingOrders: any = '';
    var IsshoppingOrders = false;
    this.ServiceChangeRequestService.getIsshoppingOrders(data.applicationId).subscribe((result) => {
      shoppingOrders = result
      IsshoppingOrders = shoppingOrders != null ? true: false;

      const dialogref = this.matdialog.open(ManageCancellationPopupComponent, {
        autoFocus: false,
        disableClose: true,
        panelClass: 'mat-dialog',
        width: "40%",
        data: {
          head: 'Cancellation Confirmation',
          title: title,
          data: data,
          ismanual: ismanual,
          isamend: 'isamend',
          IsshoppingOrders: IsshoppingOrders,
        }
      });
      dialogref.afterClosed().subscribe((result) => {
        console.log(result)

        if (result.isAgree == "yes") {
          let value = result.data;
          let postdata: any = {};
          var cancelRequestStatus = data.changeRequestStatus;
          data.changeRequestStatus = this.ChangeRequestStatusType.CancellationPending;
          postdata.id = data.serviceChangeRequestId;
          postdata.vumatelNetworkIdentifier = value.vumatelNetworkIdentifier;
          postdata.balwinComplexType = value.balwinComplexType;
          postdata.balwinComplexUnitNo = value.complexUnitNo;
          postdata.changeRequestStatus = data.changeRequestStatus;
          if (data.requestedCancellationDate != value.effectivedate) {
            value.effectivedate = this.formatDate(value.effectivedate);
          }
          postdata.approveCancellationTs = value.effectivedate;

          postdata.isAmend = isamend;
          if (ismanual) {
            console.log(ismanual)
            postdata.isApprove = false;
          }
          else
            postdata.isApprove = true;
          postdata.vumetalReason = value.cancelreason.key;
          postdata.FrogfootReason = value.Frongfootreason.key;
          postdata.FrogfootadditionalInformation = value.Frongfootreason.value;
          console.log(postdata);


          this.ServiceChangeRequestService.save(postdata).subscribe((result) => {
            console.log(result);
            if (result) {
              if (result.length == 2) {

                const dialogref = this.matdialog.open(ManageCancellationPopupComponent, {
                  autoFocus: false,
                  disableClose: true,
                  panelClass: 'mat-dialog',
                  width: "30%",
                  data: {
                    title: 'chooseAddress',
                    data: result[1],
                    ismanual: ismanual,
                    isamend: 'isamend',
                    IsshoppingOrders: IsshoppingOrders,
                  }
                });
                dialogref.afterClosed().subscribe((result) => {
                  if (result.isAgree == "yes") {
                    postdata.AEXAccountId = result.SelectedPremisesAddressId;
                    postdata.applicationId = result.applicationId;
                    this.ServiceChangeRequestService.save(postdata).subscribe((result) => {
                      if (result) {
                        if (cancelRequestStatus == this.ChangeRequestStatusType.NewCancellationRequest && result.radioResult) {
                          this.ServiceChangeRequestService.ChangeOrderLineItem(shoppingOrders, postdata.approveCancellationTs).subscribe((result) => {
                          })
                        }
                        if (result.result != undefined) {
                          if (result.result == "Ok") {

                            if (cancelRequestStatus == this.ChangeRequestStatusType.NewCancellationRequest) {
                              this.GenerateCancellationFeesUltimateCustomer(postdata.id);
                              var postcancellationservicemail: any = {};
                              postcancellationservicemail.applicationId = data.applicationId;
                              postcancellationservicemail.serviceProviderId = data.serviceProviderId;
                              postcancellationservicemail.ApproveCancellationTs = moment(result.ApproveCancellationTs, 'YYYY/MM/DD').format('YYYY/MM/DD');    //change result. name after using name in popup
                              this.ServiceChangeRequestService.CancellationOfServiceMailToServiceProvider(postcancellationservicemail).subscribe((result) => {
                                this.toastr.showSuccess("Updated successfully!");
                                this.clearFilter();

                              })
                            }
                            else
                              this.toastr.showSuccess("Updated successfully!");
                          }
                          else if (result.result == "Error") {
                            if (result.messages.contractEndDate != null) {
                              this.toastr.showError("Opps", result.messages.contractEndDate);
                              this.clearFilter();
                            }
                            else if (result.messages.noFieldSpecified != null) {
                              this.toastr.showError("Opps", result.messages.noFieldSpecified);
                              this.clearFilter();
                            }
                            else if (result.messages.reason != null) {
                              this.toastr.showError("Opps", result.messages.reason);
                              this.clearFilter();
                            }
                            else {
                              this.toastr.showError(result);
                              this.clearFilter();
                            }
                          }
                          else if (result.result.effective_date != null && result.result.orderreference == null) {
                            this.toastr.showError("Opps", result.result.effective_date);
                            this.clearFilter();

                          }

                        }
                        else {
                          if (cancelRequestStatus == this.ChangeRequestStatusType.NewCancellationRequest) {
                            this.GenerateCancellationFeesUltimateCustomer(postdata.id);
                            var postcancellationservicemail: any = {};
                            postcancellationservicemail.applicationId = data.applicationId;
                            postcancellationservicemail.serviceProviderId = data.serviceProviderId;
                            postcancellationservicemail.ApproveCancellationTs = moment(result.ApproveCancellationTs, 'YYYY/MM/DD').format('YYYY/MM/DD');    //change result. name after using name in popup
                            this.ServiceChangeRequestService.CancellationOfServiceMailToServiceProvider(postcancellationservicemail).subscribe((result) => {
                              this.toastr.showSuccess("Updated successfully!");
                              this.clearFilter();

                            })
                          }
                          else {
                            this.toastr.showSuccess("Updated successfully!");
                            this.clearFilter();
                          }
                        }
                      }
                      else {
                        this.toastr.showError("Sorry, something went wrong!!");
                      }
                    })
                  }

                })
                // postdata.approveCancellationTs = 


              }
              else {
                if (cancelRequestStatus == this.ChangeRequestStatusType.NewCancellationRequest && result.radioResult) {
                }
                if (data.serviceProviderId == 6) {
                  if (result.result != undefined) {
                    if (result.result == "Ok") {

                      if (cancelRequestStatus == this.ChangeRequestStatusType.NewCancellationRequest) {
                        this.GenerateCancellationFeesUltimateCustomer(postdata.id);
                        var postcancellationservicemail: any = {};
                        postcancellationservicemail.applicationId = data.applicationId;
                        postcancellationservicemail.serviceProviderId = data.serviceProviderId;
                        postcancellationservicemail.ApproveCancellationTs = moment(result.ApproveCancellationTs, 'YYYY/MM/DD').format('YYYY/MM/DD');    //change result. name after using name in popup
                        this.ServiceChangeRequestService.CancellationOfServiceMailToServiceProvider(postcancellationservicemail).subscribe((result) => {
                          this.toastr.showSuccess("Updated successfully!");
                          this.clearFilter();

                        })
                      }
                      else {
                        this.toastr.showSuccess("Updated successfully!");
                        this.clearFilter();

                      }
                    }
                    else if (result.success == false) {
                      if (result.errors != "") {
                        this.toastr.showError(result.errors);
                        this.clearFilter();
                      }

                      else if (result.warnings != "") {
                        this.toastr.showError(result.errors);
                        this.clearFilter();
                      }
                    }
                    else if (result == null)
                      this.toastr.showError("Sorry, something went wrong!!");
                  }
                  else {
                    if (cancelRequestStatus == this.ChangeRequestStatusType.NewCancellationRequest) {
                      this.GenerateCancellationFeesUltimateCustomer(postdata.id);
                      var postcancellationservicemail: any = {};
                      postcancellationservicemail.applicationId = data.applicationId;
                      postcancellationservicemail.serviceProviderId = data.serviceProviderId;
                      postcancellationservicemail.ApproveCancellationTs = moment(result.ApproveCancellationTs, 'YYYY/MM/DD').format('YYYY/MM/DD');    //change result. name after using name in popup
                      this.ServiceChangeRequestService.CancellationOfServiceMailToServiceProvider(postcancellationservicemail).subscribe((result) => {
                        this.toastr.showSuccess("Updated successfully!");
                        this.clearFilter();

                      })
                    }
                    else {
                      this.toastr.showSuccess("Updated successfully!");
                      this.clearFilter();

                    }
                  }
                }
                else {
                  if (result.result != undefined) {
                    if (result.result == "Ok") {

                      if (cancelRequestStatus == this.ChangeRequestStatusType.NewCancellationRequest) {
                        this.GenerateCancellationFeesUltimateCustomer(postdata.id);
                        var postcancellationservicemail: any = {};
                        postcancellationservicemail.applicationId = data.applicationId;
                        postcancellationservicemail.serviceProviderId = data.serviceProviderId;
                        postcancellationservicemail.ApproveCancellationTs = moment(result.ApproveCancellationTs, 'YYYY/MM/DD').format('YYYY/MM/DD');    //change result. name after using name in popup
                        this.ServiceChangeRequestService.CancellationOfServiceMailToServiceProvider(postcancellationservicemail).subscribe((result) => {
                          this.toastr.showSuccess("Updated successfully!");
                          this.clearFilter();

                        })
                      }
                      else
                        this.toastr.showSuccess("Updated successfully!");
                    }
                    else if (result.result == "Error") {
                      if (result.messages.contractEndDate != null) {
                        this.toastr.showError("Opps", result.messages.contractEndDate);
                        this.clearFilter();
                      }
                      else if (result.messages.noFieldSpecified != null) {
                        this.toastr.showError("Opps", result.messages.noFieldSpecified);
                        this.clearFilter();
                      }
                      else if (result.messages.reason != null) {
                        this.toastr.showError("Opps", result.messages.reason);
                        this.clearFilter();
                      }
                      else {
                        this.toastr.showError(result);
                        this.clearFilter();
                      }
                    }
                    else if (result.result.effective_date != null && result.result.orderreference == null) {
                      this.toastr.showError("Opps", result.result.effective_date);
                      this.clearFilter();

                    }

                  }
                  else {
                    if (cancelRequestStatus == this.ChangeRequestStatusType.NewCancellationRequest) {
                      this.GenerateCancellationFeesUltimateCustomer(postdata.id);
                      var postcancellationservicemail: any = {};
                      postcancellationservicemail.applicationId = data.applicationId;
                      postcancellationservicemail.serviceProviderId = data.serviceProviderId;
                      postcancellationservicemail.ApproveCancellationTs = moment(result.approveCancellationTs, 'YYYY/MM/DD').format('YYYY/MM/DD');    //change result. name after using name in popup
                      this.ServiceChangeRequestService.CancellationOfServiceMailToServiceProvider(postcancellationservicemail).subscribe((result) => {
                        this.toastr.showSuccess("Updated successfully!");
                        this.clearFilter();

                      })
                    }
                    else {
                      this.toastr.showSuccess("Updated successfully!");
                      this.clearFilter();
                    }
                  }
                }
              }
            }
            else {
              this.toastr.showError("Sorry, something went wrong!!");
            }
          })
        }
      })
    })

  }


  GenerateCancellationFeesUltimateCustomer(Id) {
    var serviceChangeRequestId = Id;
    this.reportservice.generateCancellationFee(serviceChangeRequestId).subscribe(res => { });
  }


  reject(data) {
    let title = "reject"
    const dialogref = this.matdialog.open(ManageCancellationPopupComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'mat-dialog',
      width: "40%",
      data: {
        head: 'Reason for Reject',
        title: title,
        data: data,
      }
    });
    dialogref.afterClosed().subscribe((result) => {
      console.log(result)
      if (result) {
        if (result.isAgree == 'yes') {
          let value = result.data;
          var postdata: any = {};
          this.retentionAgentName = value.retentionAgentName,
            data.changeRequestStatus = ChangeRequestStatusType.CancellationRejected;
          data.reason = value.reason;
          postdata.retentionAgentUserId = value.retentionAgent;
          postdata.id = data.serviceChangeRequestId;
          postdata.changeRequestStatus = data.changeRequestStatus;
          postdata.cancellationRejectReasonType = value.reason;
          postdata.RetentionPromoCode = value.retentionPromoCode;
          postdata.IsHasRetentionPromo = value.hasRetentionPromo;
          postdata.applicationId = data.applicationId;
          console.log(postdata)

          this.ServiceChangeRequestService.save(postdata).subscribe((result) => {
            console.log(result);
            if (result)
              if (result.result != undefined) {
                if (result.result.effective_date != null && result.result.orderreference == null) {
                  this.toastr.showError(result.result.effective_date);
                }
              }
              else {
                this.ServiceChangeRequestService.EnableOrderlineItems(data.applicationId).subscribe((result) => {
                  this.toastr.showSuccess("Updated successfully");
                  this.clearFilter();

                })
              }
          });
        }
      }
    });

  }

}  